import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../providers/authProvider/AuthContext';
import DataUndefined from '../../pages/DataUndifaend/DataUndefaind';

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
    const { isAuthenticated, loading, hasAnyRole, userRoles } = useAuth();

    if (loading) {
        return <DataUndefined text="Идет загрузка..." />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/auth" replace />;
    }

    // Если есть requiredRoles и пользователь не имеет ни одной из них
    if (requiredRoles.length > 0 && !hasAnyRole(requiredRoles)) {
        // Проверяем, является ли пользователь планограмщиком
        const userRoleNames = userRoles.map(role => role.name);
        const isPlannogrammer = userRoleNames.some(name =>
            ["Планограмщик", "Обычный Планограмщик", "Технолог ГВ", "Главный технолог ГВ"].includes(name)
        );

        // Если пользователь планограмщик - отправляем на планограммы
        if (isPlannogrammer) {
            return <Navigate to="/PlannogrammList" replace />;
        }

        // Иначе на главную
        return <Navigate to="/main" replace />;
    }

    return children;
};

export default ProtectedRoute;